// extracted by mini-css-extract-plugin
export default {"comments":"le64O2XN"};